var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { Inject } from "~/core/decorator";
import { Service } from '~/core/service';
var PrincipalService = /** @class */ (function (_super) {
    __extends(PrincipalService, _super);
    function PrincipalService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取委托方列表
     */
    PrincipalService.prototype.getPrincipalList = function (data, page) {
        return this.netService.send({
            server: domainService.principalController.getPrincipalList,
            data: data,
            page: page
        });
    };
    /**
     * 新增委托方信息
     */
    PrincipalService.prototype.addPrincipal = function (data) {
        return this.netService.send({
            server: domainService.principalController.addPrincipal,
            data: data
        });
    };
    /**
     * 修改委托方信息
     */
    PrincipalService.prototype.updatePrincipal = function (data) {
        return this.netService.send({
            server: domainService.principalController.updatePrincipal,
            data: data
        });
    };
    /**
     * 收款账户删除
     */
    PrincipalService.prototype.deleteReceivAccountById = function (receivAccountId) {
        return this.netService.send({
            server: domainService.principalController.deleteReceivAccountById,
            data: {
                receivAccountId: receivAccountId
            }
        });
    };
    /**
     * 佣金设置删除
     */
    PrincipalService.prototype.deleteCommissionDetailById = function (commissionDetailId) {
        return this.netService.send({
            server: domainService.principalController.deleteCommissionDetailById,
            data: {
                commissionDetailId: commissionDetailId
            }
        });
    };
    __decorate([
        Inject()
    ], PrincipalService.prototype, "netService", void 0);
    return PrincipalService;
}(Service));
export { PrincipalService };
